import { set } from "lodash";
import { ON_EGRESSED } from "./constants";

export default {
  [ON_EGRESSED] (state, value) {
    state.egressed = value;
  },
  ADD_DIVERSITY: (state, {
    gender,
    social_name,
    breed,
    pronoun,
    is_egression,
    pcd_reability,
    deficiencies
  }) => {
    set(state, 'gender', gender);
    set(state, 'social_name', social_name);
    set(state, 'breed', breed);
    set(state, 'pronoun', pronoun);
    set(state, 'is_egression', is_egression);
    set(state, 'pcd_reability', pcd_reability);
    set(state, 'deficiencies', deficiencies);
  }
}